<script lang="ts">
    
    import { fade } from 'svelte/transition';
    import { Col, Container, Row } from "sveltestrap";
    import TopBar from "../Components/TopBar.svelte";
    import RoutesList from '../Components/RoutesList.svelte';

</script>

<div class="view scroll" transition:fade>
    <TopBar backUrl="/" />

    <Container>
        <Row>
            <Col class="py-3">
                <RoutesList />
            </Col>
        </Row>
    </Container>
</div>
